<div class="cta">
  <div class="cta__container">
    <div class="cta__block" data-aos="fade-up">
      <div class="cta__content">
        <h2 class="heading-2">
          {{ 'cta.empowerSuccess' | translate }}

          <span class="gradient-span">Riddick’s Partners</span>
        </h2>

        <div class="cta__content_buttons-wrap">
          <ui-button
            appereance="flat"
            [fullWidth]="true"
            [label]="'general.getStarted' | translate"
            size="m"
            (click)="navigateToSignUp()"
          />
        </div>
      </div>
      <div class="cta__side">
        <div class="cta__side_regular">
          <div class="cta__side_paragraph">Riddick's Partners {{ 'cta.partnersSet' | translate }}</div>
          <div class="cta__side_badge-wrap">
            <div class="cta__side_wrap-small">
              <div class="cta-badge">
                <ui-icon iconName="check" size="xs2" />
                <div>{{ 'forAffiliates.exclusiveOffers' | translate }}</div>
              </div>

              <div class="cta-badge empty"></div>
            </div>

            <div class="cta__side_wrap-small">
              <div class="cta-badge">
                <ui-icon iconName="check" size="xs2" />
                <div>{{ 'runningBanner.trafficAnalytics' | translate }}</div>
              </div>

              <div class="cta-badge empty"></div>
            </div>
            <div class="cta__side_wrap-small">
              <div class="cta-badge">
                <ui-icon iconName="check" size="xs2" />
                <div>{{ 'runningBanner.legalTeam' | translate }}</div>
              </div>

              <div class="cta-badge empty"></div>
            </div>
          </div>
        </div>
        <div class="cta__side_overlay"></div>
        <div class="cta__side_border"></div>
      </div>
    </div>
  </div>
</div>
